//////////////////////////////////////////
/// .template-shopping-guide の最初のアコーディオンを開く
//////////////////////////////////////////
document.addEventListener("DOMContentLoaded", function () {
  const shoppingGuidePage = document.querySelector(".template-shopping-guide");
  if (shoppingGuidePage) {
    // template-shopping-guide内の最初のFAQアイテムを取得
    const firstFaqItem = shoppingGuidePage.querySelector(".faq__item");
    if (firstFaqItem) {
      const firstButton = firstFaqItem.querySelector("button.collapsible-toggle");
      if (firstButton) {
        // aria-expandedをtrueに設定
        firstButton.setAttribute("aria-expanded", "true");

        // 対応する collapsible-content を表示
        const controlsId = firstButton.getAttribute("aria-controls");
        if (controlsId) {
          const content = document.getElementById(controlsId);
          if (content) {
            content.classList.add("is-open");
          }
        }
      }
    }
  }
});
